import { createModel } from "@rematch/core";

import type { RootModel } from '.';
import { PaginationFactory } from '../factory';
import { SystemUserTypes } from '../types';

export interface SystemUserStoreProps {
    admin: SystemUserTypes.Model,
    pagination: PaginationFactory<SystemUserTypes.Model>,
    modal: {
        details: boolean,
    },
    loading: {
        fetchMany: boolean,
        create: boolean,
        update: boolean,
        getById: boolean,
    },
};

export const systemUserInitialState = {
    admin: {} as SystemUserTypes.Model,
    pagination: {
        items: [],
        page: 1,
        perPage: 10,
        total: 0
    } as PaginationFactory<SystemUserTypes.Model>,
    loading: {
        fetchMany: false,
        create: false,
        update: false,
        getById: false,
    },
    modal: {
        details: false,
    }
};

export const systemUser = createModel<RootModel>()({
    state: systemUserInitialState,
    reducers: {
        boot: (store) => {
            store = systemUserInitialState;
        },
        setAdmin: (
            store,
            admin: SystemUserTypes.Model
        ) => {
            store.admin = admin;
        },
        toggleModal: (store, prop: keyof SystemUserStoreProps['modal'], v: boolean) => {
            if (!store.modal) {
                store.modal = systemUserInitialState.modal;
            }

            if (typeof store.modal[prop] !== 'boolean' || store.modal[prop] === undefined) {
                store.modal = {
                    ...store.modal,
                    [prop]: v,
                };
            }

            store.modal[prop] = v;
        },
        addPaginationItem: (store, item: SystemUserTypes.Model) => {
            store.pagination.items = [...(store.pagination.items || []), item];
        },
        toggleLoading: (
            store, prop: keyof SystemUserStoreProps['loading'], v: boolean) => {
                store.loading[prop] = v;
            },
        setPagination: 
            (store, pagination: PaginationFactory<SystemUserTypes.Model>) => {
                store.pagination = pagination;
            },

    },
});
